import React, { useState } from "react";
import "./Biography.css";

const Biography = () => {
    return (
        <div className="biography-wrapper">
            <div className="bio-contents-wrapper">
                <header>
                    <h1>Biography</h1>
                </header>

                <section>
                    <h2>基本情報</h2>
                    <ul>
                        <li><strong>名前:</strong> アオアヤマタロウ - AoyamaTaro</li>
                        <li><strong>出身地:</strong> 東京</li>
                        <li><strong>活動地:</strong> 東京</li>
                        <li><strong>職業:</strong> 音楽家、ベース奏者、作曲家、編曲家、Webエンジニア</li>
                        <li><strong>趣味:</strong> 旅行、漫画、映画、小説、美味しいものを食べること</li>
                    </ul>
                </section>

                <section>
                    <h2>活動歴</h2>
                    <p>幼少期より家にあったエレクトーンを演奏し、中学生からギターを始め、同時に作曲にも取り組むようになる。高校生時代にベースを手にし、バンド活動を開始。大学在学中もバンド活動を続けながら、積極的にサポート活動を行う。卒業後は、自身のリーダーバンドとして9人編成のソウル＆ファンクバンドを率い活動。そのバンドが解散した後、サポートベーシストやレコーディングサポートを中心に活動を展開。</p>
                    <p>2018年、2019年にはロシアでの公演、2024年にはタイでの海外公演を経験し、さらに活動の幅を広げる。2018年より「踊るミエ」のバックバンド、ザ・ジャック・ポッツに参加。</p>
                </section>

                <section>
                    <h2>バンド活動</h2>
                    <table>
                        <thead>
                            <tr>
                                <th>年</th>
                                <th>バンド名</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr><td>2002</td><td>小沢健二トリビュートバンド（サポート）</td></tr>
                            <tr><td>2003</td><td>東京マハラジャンクション</td></tr>
                            <tr><td>2005</td><td>Jun Ando（サポート）</td></tr>
                            <tr><td>2007</td><td>コークジーンズ（サポートから加入）</td></tr>
                            <tr><td>2010</td><td>宵闇パラソル（サポート）</td></tr>
                            <tr><td>2010</td><td>Ramirezi（サポート）</td></tr>
                            <tr><td>2015</td><td>ルック松下（サポート）</td></tr>
                            <tr><td>2015</td><td>Robert The Thief（サポート）</td></tr>
                            <tr><td>2016</td><td>The Sugars</td></tr>
                            <tr><td>2018</td><td>踊るミエとザ・ジャック・ポッツ</td></tr>
                            <tr><td>2021</td><td>oto-nova</td></tr>
                            <tr><td>2022</td><td>Megalis</td></tr>
                            <tr><td>2022</td><td>The Soul Mates</td></tr>
                            <tr><td>2023</td><td>OZ3</td></tr>
                        </tbody>
                    </table>
                </section>

                <section>
                    <h2>参加アルバム</h2>
                    <table>
                        <thead>
                            <tr>
                                <th>年</th>
                                <th>アルバム名</th>
                                <th>アーティスト</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr><td>2009</td><td><strong>サルバトーレ！</strong></td><td>コークジーンズ</td></tr>
                            <tr><td>2012</td><td><strong>宵闇色の傘さして</strong></td><td>宵闇パラソル</td></tr>
                            <tr><td>2017</td><td><strong>DCYN</strong></td><td>Robert The Thief</td></tr>
                            <tr><td>2018</td><td><strong>BURN!</strong></td><td>The SUGARS</td></tr>
                            <tr><td>2023</td><td><strong>サイケデリック・トウキョウ</strong></td><td>踊るミエとザ・ジャック・ポッツ</td></tr>
                        </tbody>
                    </table>
                </section>

                <section className="bio-section-end">
                    <h2>活動実績</h2>
                    <ul>
                        <li>2005年頃から作曲・編曲を本格的に開始。</li>
                        <li>2018年、2019年にはロシアで公演を実施。</li>
                        <li>2024年、タイでの公演に参加し、南アフリカのバンドと共演。</li>
                        <li>映画『EXPO’70前衛の記憶～アコを探して』に楽曲提供。</li>
                        <li>踊るミエとザ・ジャック・ポッツのメンバーとして平山みき氏と共演。</li>
                        <li>営業バンドとしてレストランやホールでのパーティ演奏を多数経験。</li>
                    </ul>
                </section>
            </div>
        </div>
    );

}

export default Biography;